import { render, staticRenderFns } from "./AdminInviteUser.vue?vue&type=template&id=35ded786"
import script from "./AdminInviteUser.vue?vue&type=script&lang=js"
export * from "./AdminInviteUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports